import { usePrevious, useThrottle } from "@/utils/chat/index";
import { Button, Drawer, Form, Input, Radio, Tooltip, message as toast } from "antd";
import React, { useCallback, useEffect, useMemo, useState, useRef } from "react";
import styles from "./index.module.less";
import { AI_CHAT_PREDICT, ChatMessage, ChatMessageType } from "@/types/chat";
import { connect } from "dvajs";
import { AI_CHAT_PREDICT_TYPE, sendIntentMessageToAI, showIntentTail } from "@/utils/chat/message";
import Context from "@/components/chat/context";
import { throttle } from "lodash";

function AiIntentTail(props: any) {
  const { message, currentEmployee, updateCurrentAIRobot, clsName } = props;
  const { isLLMAI } = React.useContext(Context);
  const isIntent = useMemo(() => {
    return isLLMAI && showIntentTail(message);
  }, [message, isLLMAI]);
  // 发送意图识别消息
  const sendIntentMessage = useThrottle(
    useCallback(async () => {
      console.log(`tj:>>>updateCurrentAIRobot1111111>`);
      const { prompt, predictType } = message?.intentData || {};
      sendIntentMessageToAI({
        currentEmployee,
        message,
        predictType,
        prompt
      });
    }, [currentEmployee, message]),
    6 * 1000
  );

  // 显示内容
  const textContent = useMemo(() => {
    return message?.intentData?.tip || "点击推荐内容";
  }, [message?.intentData]);

  const clsKey = useMemo(() => {
    const { type } = message;
    const { predictType } = message?.intentData || {};
    if (predictType === AI_CHAT_PREDICT.FILE_SUMMARY) {
      return type === ChatMessageType.FILE || ChatMessageType.EGOV_FILE
        ? "DocTail_LocalFile"
        : "DocTail_CollabDoc";
    }
    if ([AI_CHAT_PREDICT.CREATE_SCHEDULE, AI_CHAT_PREDICT.CREATE_MEETING].includes(predictType)) {
      return "SmartSchedule";
    }
    if ([AI_CHAT_PREDICT.AGENT_CONTACT].includes(predictType)) {
      return "SmartSmartFindPerson_TailSchedule";
    }
    return "";
  }, [message]);

  return isIntent ? (
    <div
      clstag={`pageclick|keycount|Xtbg_Msg_${clsKey}`}
      className={`${styles["ai-intent-tail-wrap"]} ${styles[clsName]}`}
      onClick={sendIntentMessage}
    >
      <span className={styles["icon"]} />
      <span className={styles["text"]}>{textContent}</span>
    </div>
  ) : null;
}
function mapStateToProps({ chat }: any) {
  return {
    selectedSession: chat.selectedSession,
    currentEmployee: chat.currentEmployee,
    llmSetting: chat.llmSetting
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    pushChatMessage(data: { sessionId: string; message: Partial<ChatMessage> }) {
      dispatch({ type: "chat/pushChatMessage", payload: data });
    },
    updateCurrentAIRobot(payload: any) {
      dispatch({ type: "chat/updateCurrentAIRobot", payload });
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(AiIntentTail);
